import { useBreadcrumb } from '../hooks/useBreadcrumb';

type LinkProps = {
	children: string;
};

const Link = ({ children }: LinkProps) => {
	const { blockClass } = useBreadcrumb();

	const renderClass = () => {
		return (
			blockClass &&
			`link--${blockClass} link--${blockClass}--1 vtex-breadcrumb-1-x-link--${blockClass} vtex-breadcrumb-1-x-link--${blockClass}--1`
		);
	};

	return (
		<a
			onClick={() => (window.location.hash = 'default-1')}
			className={`link vtex-breadcrumb-1-x-link ${renderClass()} dib pv1 link ph2 c-muted-2 hover-c-link`}
		>
			{children}
		</a>
	);
};

export default Link;
